import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperAddLeadDialog: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
  };
});
